export default [
    'https://aquarium.org.ru/img/cap/BG1.jpg',
    'https://aquarium.org.ru/img/cap/BG2.jpg',
    'https://aquarium.org.ru/img/cap/BG3.jpg',
    'https://aquarium.org.ru/img/cap/BG4.jpg',
    'https://aquarium.org.ru/img/cap/BG5.jpg',
    'https://aquarium.org.ru/img/cap/BG6.jpg',
    'https://aquarium.org.ru/img/cap/BG7.jpg',
    'https://aquarium.org.ru/img/cap/BG8.jpg',
    'https://aquarium.org.ru/img/cap/BG9.jpg',
    'https://aquarium.org.ru/img/cap/BG10.jpg',
    'https://aquarium.org.ru/img/cap/BG11.jpg',
];
